import {addTopSearchColumn, fnToastrFormError} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnUserCompaniesTable = function () {

    var tableName = '#datatable-user-companies';
    var modal = $('#modal-edit-user-companies');


    if (!element_exists(tableName)) return false;

    $('#form-edit-user-companies').off('submit').on('submit', function (e) {
        e.preventDefault();

        var formData = $('#form-edit-user-companies').serialize();

        $.ajax({
            type: 'POST',
            url: 'saveCompanyUsers',
            data: formData,
            success: function (response) {
                $(tableName).DataTable().ajax.reload(null, false);
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    $('#datatable-user-companies tbody').off('click', 'tr');
    $('#datatable-user-companies tbody').on('click', 'tr', function () {

        var tableData = table.row(this).data();

        $('#form-edit-user-companies').find('#company_id_input_user_company').val(tableData.id);

        $.ajax({
            type: 'POST',
            url: 'getKeepers',
            data: {
                company_id: tableData.id
            },
            success: function (response) {
                var element = $('#select_users');
                element.html('');

                 $.each(response.user_groups, function (index, value) {
                     //Here we will handle the checking if the user group is assigned to the company
                    element.append('<option type="checkbox" value="ug-' + response.user_groups[index]['id'] + '" '+ (response.user_groups[index]['selected'] ? 'selected':'') + '  > ' + response.user_groups[index]['name'] + '</option>');
                });

                modal.on('change', function (e) {

                    var selectedValue = $(this).val();
                    $.each(response.user_groups, function (index, value) {
                        var inputGroup = $('input[type="checkbox"][value="ug-' + response.user_groups[index]['id'] + '"]');
                        inputGroup .on('change', function(e) {
                            var users = response.user_groups[index]['users'];
                            if(inputGroup.prop('checked')){
                                $.each(users, function (index, user) {
                                    //select all users from group
                                    var input = $('input[type="checkbox"][value="' + user.id + '"]');

                                    if(!input.prop('checked')){
                                        input.trigger('click');
                                    }
                                })
                            }else{
                                $.each(users, function (index, user) {
                                    //deselect all users from group
                                    var input = $('input[type="checkbox"][value="' + user.id + '"]');

                                    if(input.prop('checked')){
                                        input.trigger('click');
                                    }
                                });
                            }
                        });
                    });
                });

                $.each(response.keepers, function (index, value) {
                    element.append('<option type="checkbox" value="' + response.keepers[index]['id'] + '"> ' + response.keepers[index]['name'] + '</option>');
                });

                $.each(response.user_companies, function (index, value) {
                    element.find('option[value="' + response.user_companies[index]['user_id'] + '"]').prop('selected', true);
                });

                var lang = allLangFiles.roles.select;

                element.multiselect({
                    columns: columns,
                    search: true,
                    selectAll: true,
                    texts: {
                        placeholder: lang.texts.placeholder,
                        search: lang.texts.search,
                        selectedOptions: lang.texts.selectedOptions,
                        selectAll: lang.texts.selectAll,
                        unselectAll: lang.texts.unselectAll,
                        noneSelected: lang.texts.noneSelected,
                    }
                });
                $('#select_users').multiselect('reload');

                var firstInput = $('li:has(input[type="checkbox"][value^="ug-"])').first();
                var lastInput = $('li:has(input[type="checkbox"][value^="ug-"])').last();

                if (!firstInput.prev('#begin-groups').length) {
                    firstInput.before(`<hr><h6 id="begin-groups" class="ml-1" style="margin-left: 1rem;">${allLangFiles["user-groups"].groups}</h6>`);
                }
                if (!lastInput.next('#end-groups').length) {
                    lastInput.after('<hr id="end-groups">');
                }
            },
            error: fnToastrFormError,
        })
        modal.modal('show');
    });

    var columns = [
        {data: 'id'},
        {
            data: 'name',
            render: function (data, type, row) {
                if (row.deactivated_at) {
                    return data + ' (' + allLangFiles.companies.deactivated + ')';
                }
                return data;
            },
        },
        {data: 'user_names'},
        {data: 'has_salary'},
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {visible: false, targets: 0},
        {className: "p-l-10", width: "40%", targets: 1},
        {className: "p-l-10", width: "40%", targets: 2},
        {className: "p-l-10", width: "20%", targets: 3},
    ];

    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');
    var table = $(tableName).DataTable({
        language: allLangFiles.datatables,
        ajax: {
            url: '/getUserCompanies',
        },
        columns: columns,
        columnDefs: columnDefs,
        destroy: true,
        scrollX: true,
        dom: 'fltipB',
        buttons: [
            'csv', 'excel',
        ],
        orderCellsTop: true,
        lengthMenu: [10, 25, 50, 75, 100],
        initComplete: function (settings, json) {
            table.draw();
        },
    });
    addTopSearchColumn(tableName, table);
    redesignDataTablesHeader(tableName, false, null);
};
